import Api from '../../api/unlicensedCarOutIn'
import Dict from '../../api/dict'
export default {
  namespace: 'imgstore', // 注意定义namespace, 将会在store中存储
  state: {
    img_upload_cache: [],
    img_paths: [],
    img_status: 'ready' // 上传状态 ready selected uploading finished
  },
  getters: {
    img_upload_cache: state => state.img_upload_cache,
    img_paths: state => state.img_paths,
    img_status: state => state.img_status,
  },
  actions: {
  },
  mutations: {
    set_img_upload_cache (state, arg) {
      state.img_upload_cache = arg
    },
    set_img_paths (state, arg) {
      state.img_paths = arg
    },
    set_img_status (state, arg) {
      state.img_status = arg
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/imgstore.js